<template>
    <v-container>
        <v-layout row>
          <p v-if="!this.$store.getters.getCurrentDistrict">Оберіть, будь ласка, район</p>
          <div v-else-if="this.stat.length > 0">
            <v-flex xs12>
                <h3>Список кадастрів в обраному районі</h3>
            </v-flex>

            <v-simple-table fixed-header height="80vh">
              <thead>
                <tr>
                  <th class="text-left">Кадастровий номер</th>
                  <th class="text-left">Площа</th>
                  <th class="text-left cell-phone">Телефон</th>
                  <th class="text-left cell-region">Область</th>
                  <th class="text-left cell-district">Район</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in stat" :key="item.kadastr">
                  <td>{{ item.kadastr }}</td>
                  <td>{{ item.area }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.region }}</td>
                  <td>{{ item.district }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <p v-else>
            Дані для даного району не знайдені в базі
          </p>
        </v-layout>
    </v-container>
</template>

<script>
  export default {
    data () {
      return {
        stat: []
      }
    },
    created() {
      this.loadStat()
    },
    computed: {
      distictChangedListener() {
        this.stat = []
        return this.$store.getters.getCurrentDistrict
      }
    },
    watch: {
      distictChangedListener: function (value) {
        this.loadStat()
      }
    },
    methods: {
      loadStat() {
        self = this
        if (!this.$store.getters.getCurrentDistrict) {
          return;
        }

        this.$http.get('stat/' + this.$store.getters.getCurrentDistrict)
          .then(response => {
            return response.json()
          })
          .then(stat => {
            if (stat.length == 0) {
              this.$store.commit('showAlert', 'Земельні ділянки для даного району не знайдено');
              return;
            }

            stat.forEach(function(el, index) {
              stat[index]['region'] = self.$store.getters.getCurrentRegionCaption
              stat[index]['district'] = self.$store.getters.getCurrentDistrictCaption
            })

            this.stat = stat;
          })
      }
    }
  }
</script>

<style>
.cell-phone {
  width: 120px;
}
</style>